module.exports = __webpack_public_path__ + "static/media/texture-season-8.ee675982.jpg";